// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"styles_balanceWrapper__kdnLU","balanceText":"styles_balanceText__Xar0c","button":"styles_button__pCYJ9"};